(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
  function labels(root) {
    return {
      size0: root.dataset.size0,
      size1: root.dataset.size1,
      size2: root.dataset.size2,
      size3: root.dataset.size3,
      size4: root.dataset.size4,
      size5: root.dataset.size5,
      size6: root.dataset.size6,
      harrow: root.dataset.harrow,
      shortHandle: root.dataset.shortHandle,
      smallJunior: root.dataset.smallJunior,
      junior: root.dataset.junior,
      youth: root.dataset.youth,
      adult: root.dataset.adult,
      adultPro: root.dataset.adultPro,
      xsJunior: root.dataset.xsJunior,
      smallAdult: root.dataset.smallAdult,
      adultLong: root.dataset.adultLong,
      helmetJunior: root.dataset.helmetJunior,
      helmetYouth: root.dataset.helmetYouth,
      helmetAdult: root.dataset.helmetAdult,
      helmetXl: root.dataset.helmetXl,
      xs: root.dataset.xs,
      small: root.dataset.small,
      medium: root.dataset.medium,
      large: root.dataset.large,
      xl: root.dataset.xl
    };
  }

  function closeTo(value, boundaries, tolerance) {
    return boundaries.some(function (boundary) {
      return Math.abs(value - boundary) <= tolerance;
    });
  }

  document.querySelectorAll('[data-ics-product-sizer]').forEach(function (root) {
    var button = root.querySelector('[data-calculate]');
    var input = root.querySelector('[data-measure]');
    var result = root.querySelector('[data-result]');
    var sizeNode = root.querySelector('[data-size]');
    var error = root.querySelector('[data-error]');
    var boundary = root.querySelector('[data-boundary]');
    var outside = root.querySelector('[data-outside]');
    var juniorWarning = root.querySelector('[data-junior-warning]');
    var type = root.dataset.calculator;
    var l = labels(root);

    if (!button || !input || !result || !sizeNode) return;

    button.addEventListener('click', function () {
      var value = parseFloat(input.value);
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      var size = '';
      var isBoundary = false;
      var isOutside = false;
      var showJuniorWarning = false;

      if (!Number.isFinite(value) || value < min || value > max) {
        error.hidden = false;
        result.hidden = true;
        return;
      }

      if (type === 'bat') {
        if (value < 122) size = l.size0;
        else if (value < 130) size = l.size1;
        else if (value < 137) size = l.size2;
        else if (value < 145) size = l.size3;
        else if (value < 152) size = l.size4;
        else if (value < 160) size = l.size5;
        else if (value < 165) size = l.size6;
        else if (value < 170) size = l.harrow;
        else size = l.shortHandle;
        isBoundary = closeTo(value, [122, 130, 137, 145, 152, 160, 165, 170], 2);
      } else if (type === 'glove') {
        if (value < 17) size = l.smallJunior;
        else if (value < 18.25) size = l.junior;
        else if (value < 20) size = l.youth;
        else if (value < 21.75) size = l.adult;
        else size = l.adultPro;
        isBoundary = closeTo(value, [17, 18.25, 20, 21.75], 0.3);
      } else if (type === 'pad') {
        if (value < 38) size = l.xsJunior;
        else if (value < 40) size = l.smallJunior;
        else if (value < 42) size = l.junior;
        else if (value < 43) size = l.youth;
        else if (value < 44) size = l.smallAdult;
        else if (value < 46.01) size = l.adult;
        else size = l.adultLong;
        isBoundary = closeTo(value, [38, 40, 42, 43, 44, 46], 0.3);
      } else if (type === 'helmet') {
        if (value < 54) size = l.helmetJunior;
        else if (value < 58) size = l.helmetYouth;
        else if (value <= 61) size = l.helmetAdult;
        else size = l.helmetXl;
        isBoundary = closeTo(value, [54, 58, 61], 0.4);
        var ageInput = root.querySelector('[data-age]');
        var age = ageInput ? parseFloat(ageInput.value) : NaN;
        showJuniorWarning = Number.isFinite(age) && age < 12 && value >= 58;
      } else if (type === 'thigh') {
        var inches = value / 2.54;
        if (inches < 57) size = l.xs;
        else if (inches < 64) size = l.small;
        else if (inches < 69) size = l.medium;
        else if (inches < 75) size = l.large;
        else size = l.xl;
        isBoundary = closeTo(inches, [57, 64, 69, 75, 79], 0.75);
        isOutside = inches < 53 || inches >= 79;
      }

      sizeNode.textContent = size;
      error.hidden = true;
      boundary.hidden = !isBoundary;
      outside.hidden = !isOutside;
      juniorWarning.hidden = !showJuniorWarning;
      result.hidden = false;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
